// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
export const setLanguage = (context: any): void => {
  try {
    const userLang = window.navigator.language;
    if (userLang.includes("es")) {
      context.$i18n.locale = "es_MX";
    } else {
      context.$i18n.locale = "en_MX";
    }
  } catch (e) {
    return;
  }
};

export const getLanguage = (): string => {
  const userLang = window.navigator.language;
  if (typeof localStorage?.getItem === "function") {
    return (
      userLang.replace("-", "_") || localStorage.getItem("lang") || "es_MX"
    );
  }
  return "es_MX";
};

/**
 * To get just the language, example "en"
 * @returns string
 */
export const getLanguageName = (): string => getLanguage().substring(0, 2);
